import { ICellRendererParams } from 'ag-grid-community'
import { PLACEHOLDER } from './common'

/** Maps API `notificationDelivery` (user prefs: email / sms / both / neither) for admin grids and CSV. */
export function formatNotificationSettings(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return PLACEHOLDER
  }
  switch (value.toLowerCase()) {
    case 'both':
      return 'Both (Email + SMS enabled)'
    case 'email':
      return 'Email'
    case 'sms':
      return 'SMS'
    case 'neither':
      return 'None'
    default:
      return PLACEHOLDER
  }
}

export function notificationSettingsCellRenderer(
  props: ICellRendererParams<{ notificationDelivery?: string | null }>,
) {
  if (!props.data) return PLACEHOLDER
  return formatNotificationSettings(props.data.notificationDelivery)
}
